const strings = {
  title: 'Contatos Realizados',
  addContact: 'Adicionar Contato',
}

export default strings
